import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgEnterConfirmSubmit32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M22.5 9.995a.5.5 0 0 1 .492.41l.008.09V19.5a.5.5 0 0 1-.41.492L22.5 20H10.151l1.626 1.084a.5.5 0 0 1 .182.614l-.043.08a.5.5 0 0 1-.614.181l-.08-.043-3.014-2.01.015.01a.507.507 0 0 1-.092-.078l-.056-.073-.044-.092-.025-.096-.004-.033L8 19.489c0-.022.002-.043.006-.065L8 19.5l.003-.053.014-.076.03-.083.043-.075.07-.08.063-.05 3-1.999a.5.5 0 0 1 .625.775l-.07.057L10.148 19H22v-8.003L18.5 11a.5.5 0 0 1-.492-.41L18 10.5a.5.5 0 0 1 .41-.492L18.5 10z" /></SvgIcon>;
};
const Memo = memo(SvgEnterConfirmSubmit32);
export default Memo;